import React from 'react';
import { SvgIcon } from '@mui/material';

const CustomInfoIcon = (props) => {
  const circleStyle = {
    transform: 'scale(1)',
    transformOrigin: 'center',
  };

  const textStyle = {
    transform: 'scale(1)',
    transformOrigin: 'center',
    fontSize: '9px',
    dominantBaseline: 'middle',
  };

  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ width: '2em', height: '2em' }}>
      <circle
        cx="12"
        cy="12"
        r="6"
        stroke="#0078c9"
        strokeWidth="1px"
        fill="#D9D9D9"
        style={circleStyle}
      />
      <text
        x="12"
        y="13"
        textAnchor="middle"
        fill="black"
        fontFamily="Arial"
        fontWeight="700"
        style={textStyle}
      >
        i
      </text>
    </SvgIcon>
  );
};

export default CustomInfoIcon;
